import { render, staticRenderFns } from "./Inputfield.vue?vue&type=template&id=6a63f711&scoped=true&"
import script from "./Inputfield.vue?vue&type=script&lang=ts&"
export * from "./Inputfield.vue?vue&type=script&lang=ts&"
import style0 from "./Inputfield.vue?vue&type=style&index=0&id=6a63f711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63f711",
  null
  
)

export default component.exports